module.exports = __webpack_public_path__ + "img/topik_img.e3fb4161.png";